import axiosInstance from './axiosInstance';
import { TopicArea, Category, Tag } from '../types';

export async function getTopicAreas(mine?: boolean): Promise<TopicArea[]> {
  const url = mine ? '/api/topic-areas?mine=true' : '/api/topic-areas';
  const res = await axiosInstance.get(url);
  return res.data;
}

export async function getTopicArea(id: number): Promise<TopicArea> {
  const res = await axiosInstance.get(`/api/topic-areas/${id}?_embed=categories&_embed=tags`);
  return {
    ...res.data,
    categories: res.data.categories || [],
    tags: res.data.tags || [],
    main_category1_id: res.data.main_category1_id,
    main_category2_id: res.data.main_category2_id,
    main_category3_id: res.data.main_category3_id,
    is_current: res.data.is_current,
    timeline_display_compact: res.data.timeline_display_compact
  };
}

export async function createTopicArea(data: Partial<TopicArea>): Promise<{ id: number }> {
  const res = await axiosInstance.post('/api/topic-areas', data);
  return res.data;
}

export async function updateTopicArea(id: number, data: Partial<TopicArea>): Promise<void> {
  await axiosInstance.put(`/api/topic-areas/${id}`, data);
}

export async function deleteTopicArea(id: number): Promise<void> {
  await axiosInstance.delete(`/api/topic-areas/${id}`);
}

export async function getTopicAreaCategories(topicAreaId: number): Promise<Category[]> {
  try {
    const response = await axiosInstance.get(`/api/categories?topic_area_id=${topicAreaId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    return [];
  }
}

export async function getTopicAreaTags(topicAreaId: number): Promise<Tag[]> {
  try {
    const response = await axiosInstance.get(`/api/topic-area-tags/${topicAreaId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching tags:', error);
    return [];
  }
}
